<script lang="ts"></script>

<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-12 0 522 363"
  ><g
    ><g class="image"><rect width="363" height="363" x="62" fill="url(#pattern0_19244_36653)" rx="12" /></g><g
      class="icone"
      ><g filter="url(#filter0_d_19244_36653)"
        ><rect width="72" height="72" x="26" y="164" fill="#fff" rx="36" /><g
          ><path
            fill="#000091"
            d="M50.33 185v26.67H77V215H47v-30zm24.9 4.9 3.54 3.53-10.1 10.1-5-5-6.57 6.57-3.53-3.53 10.1-10.1 5 5z"
          /></g
        ></g
      ></g
    ><g class="bulle"
      ><g filter="url(#filter1_d_19244_36653)"
        ><rect width="216" height="72" x="270" y="179" fill="#fff" rx="8" /><g
          ><path fill="#ffe9e9" d="M282 195a4 4 0 0 1 4-4h158a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H286a4 4 0 0 1-4-4z" /><g
            ><g
              ><path
                fill="#ce0500"
                fill-rule="evenodd"
                d="M291 198a4 4 0 0 1 4 4v3h.5v1h-9v-1h.5v-3a4 4 0 0 1 4-4m0 1a3 3 0 0 0-3 3h1c0-1.1.9-2 2-2zm-3.89-1.6 1.06 1.06-.7.71-1.07-1.06zm7.78 0 .7.71-1.05 1.06-.71-.7zm-3.39-1.4v1.5h-1V196z"
                clip-rule="evenodd"
              /></g
            ></g
          ><path
            fill="#ce0500"
            d="m301.48 204.84 1.24-1.14c.5.64 1.17 1.03 1.86 1.03.67 0 1.08-.36 1.08-.96 0-1.55-3.82-1.13-3.82-3.97 0-1.34 1.1-2.44 2.71-2.44a3.7 3.7 0 0 1 2.94 1.42l-1.25 1.12c-.49-.63-1.04-1.05-1.68-1.05-.6 0-1 .38-1 .89 0 1.52 3.82 1.09 3.82 3.97-.02 1.58-1.24 2.53-2.8 2.53a3.8 3.8 0 0 1-3.1-1.4m12.67-1.98v-5.26h1.7v5.11c0 2.21-1.3 3.53-3.4 3.53s-3.4-1.32-3.4-3.53v-5.11h1.7v5.26c0 1.12.64 1.78 1.7 1.78 1.05 0 1.7-.66 1.7-1.78m3.94 3.14v-8.4h2.57c1.85 0 2.99.95 2.99 2.5 0 1.03-.5 1.78-1.36 2.18l2.63 3.72h-2l-2.25-3.4h-.87v3.4zm2.67-6.98h-.96v2.17h.95c.73 0 1.14-.42 1.14-1.1 0-.64-.41-1.07-1.13-1.07m3.98-1.42h1.8l2.5 6.56 2.47-6.56h1.82l-3.18 8.4h-2.23zm10 8.4v-8.4h4.9v1.42h-3.2V201h2.72v1.41h-2.71v2.16h3.19V206zm7 0v-8.4h1.7v8.4zm4.17 0v-8.4h1.7v6.85h3.2V206zm6.52 0v-8.4h1.7v6.85h3.2V206zm5.82 0 3.18-8.4h2.23l3.18 8.4h-1.81l-.8-2.18h-3.36l-.8 2.18zm3.14-3.64h2.3l-1.14-3.15zm6.87 3.64v-8.4h2.18l3.76 6.07v-6.07h1.7v8.4h-2.18l-3.76-6.07V206zm13.86-1.36c.96 0 1.71-.46 2.2-1.15l1.34 1.03a4.3 4.3 0 0 1-3.54 1.72 4.37 4.37 0 0 1-4.47-4.44c0-2.4 1.81-4.44 4.47-4.44 1.52 0 2.77.68 3.54 1.7l-1.35 1.05a2.6 2.6 0 0 0-2.2-1.15c-1.58 0-2.7 1.23-2.7 2.84s1.12 2.84 2.7 2.84m5.14 1.36v-8.4h4.9v1.42h-3.2V201h2.71v1.41h-2.71v2.16h3.2V206zm9.17 0 3.18-8.4h2.23l3.18 8.4h-1.81l-.8-2.18h-3.36l-.8 2.18zm3.14-3.64h2.3l-1.14-3.15zm10.43 2.28c.96 0 1.71-.46 2.2-1.15l1.34 1.03a4.3 4.3 0 0 1-3.54 1.72 4.37 4.37 0 0 1-4.47-4.44c0-2.4 1.81-4.44 4.47-4.44 1.52 0 2.77.68 3.54 1.7l-1.35 1.05a2.6 2.6 0 0 0-2.2-1.15c-1.58 0-2.7 1.23-2.7 2.84s1.12 2.84 2.7 2.84m4.27-5.5v-1.54h6.89v1.55h-2.6V206h-1.7v-6.85zm8.5 6.86v-8.4h1.7v8.4zm3.12-8.4h1.81l2.49 6.56 2.48-6.56h1.81l-3.18 8.4h-2.23zm10.01 8.4v-8.4h4.9v1.42h-3.2V201h2.72v1.41h-2.72v2.16h3.2V206z"
          /></g
        ><path
          fill="#161616"
          d="m282.21 233 3.71-9.8h2.6l3.71 9.8h-2.11l-.94-2.55h-3.92l-.94 2.55zm3.67-4.24h2.69l-1.35-3.68zm8.05 4.24v-7.06h1.78v.56a3 3 0 0 1 2.09-.84c1.52 0 2.74 1.05 2.74 3.14v4.2h-1.8v-4.13c0-.94-.52-1.53-1.4-1.53-.89 0-1.36.6-1.63 1.05V233zm9.08-2.58v-2.88h-1.32v-1.6h1.32v-1.76h1.79v1.76h2.16v1.6h-2.16v2.88c0 .79.42 1.1 1.12 1.1.49 0 .81-.06 1.05-.16v1.56a3 3 0 0 1-1.36.22c-1.76 0-2.6-1-2.6-2.72m6.43-5.7c-.63 0-1.16-.54-1.16-1.17s.53-1.16 1.16-1.16 1.15.53 1.15 1.16-.52 1.16-1.15 1.16m-.9 8.28v-7.06h1.79V233zm7.3-1.4c.7 0 1.27-.32 1.6-.81l1.39 1.06a3.7 3.7 0 0 1-2.98 1.43 3.7 3.7 0 0 1-3.9-3.8 3.7 3.7 0 0 1 3.9-3.82c1.28 0 2.32.56 2.98 1.43l-1.39 1.07a1.9 1.9 0 0 0-1.62-.82c-1.16 0-2.02.9-2.02 2.13 0 1.25.86 2.13 2.05 2.13m5.21-6.89c-.63 0-1.16-.53-1.16-1.16s.53-1.16 1.16-1.16 1.15.53 1.15 1.16-.52 1.16-1.15 1.16m-.9 8.29v-7.06h1.78V233zm3.92 3.44v-10.5h1.77v.58a3 3 0 0 1 2.2-.86c2.24 0 3.59 1.75 3.59 3.81s-1.35 3.81-3.59 3.81c-.96 0-1.65-.3-2.2-.85v4.01zm3.72-9.1c-.83 0-1.5.37-1.95 1.03v2.2a2.3 2.3 0 0 0 1.95 1.03c1.2 0 1.99-.9 1.99-2.13s-.79-2.13-1.99-2.13m12.03 4.51a3.7 3.7 0 0 1-3.08 1.43c-2.5 0-3.92-1.75-3.92-3.8 0-2.1 1.31-3.82 3.62-3.82 1.96 0 3.25 1.33 3.25 3.18q-.01.62-.11 1h-4.94c.17 1.31.98 1.84 2.08 1.84.77 0 1.45-.33 1.82-.84zm-3.42-4.73c-.9 0-1.51.5-1.7 1.43h3.24a1.46 1.46 0 0 0-1.54-1.43m5.03 5.88v-7.06h1.78v.7a2.5 2.5 0 0 1 1.86-.84q.36.01.62.1v1.75q-.33-.09-.79-.1c-.87 0-1.43.48-1.7.93V233zm9.46 0v-10.5h1.78V233zm10.4-1.15a3.7 3.7 0 0 1-3.07 1.43c-2.51 0-3.92-1.75-3.92-3.8 0-2.1 1.31-3.82 3.62-3.82 1.96 0 3.25 1.33 3.25 3.18q-.02.62-.11 1h-4.94c.16 1.31.98 1.84 2.08 1.84.77 0 1.44-.33 1.82-.84zm-3.41-4.73c-.91 0-1.51.5-1.7 1.43h3.24a1.46 1.46 0 0 0-1.54-1.43m4.32 4.86 1.17-1.07c.44.55.95.94 1.63.94.57 0 .86-.33.86-.75 0-1.24-3.37-.77-3.37-3.25 0-1.25 1.05-2.19 2.52-2.19 1.08 0 2.06.52 2.56 1.2l-1.17 1.04c-.37-.44-.83-.8-1.38-.8-.56 0-.82.3-.82.66 0 1.2 3.37.79 3.37 3.22-.03 1.49-1.22 2.3-2.55 2.3a3.5 3.5 0 0 1-2.82-1.3m14.17-.38c.7 0 1.26-.32 1.6-.81l1.38 1.06a3.7 3.7 0 0 1-2.98 1.43 3.7 3.7 0 0 1-3.89-3.8 3.7 3.7 0 0 1 3.9-3.82c1.28 0 2.32.56 2.97 1.43l-1.38 1.07a1.9 1.9 0 0 0-1.63-.82c-1.16 0-2.01.9-2.01 2.13 0 1.25.85 2.13 2.04 2.13m7.45 3.01c-.5 1.16-1.29 1.89-2.63 1.89a3 3 0 0 1-1.26-.22v-1.57c.22.1.56.17.86.17.7 0 1.14-.24 1.43-.96l.4-.93-2.97-7.05h1.97l1.93 4.75 1.95-4.75h1.87zm12.23-5.14c0 2.06-1.35 3.81-3.59 3.81-.96 0-1.65-.3-2.2-.85v.57h-1.77v-10.5h1.78v4.02a3 3 0 0 1 2.2-.86c2.23 0 3.58 1.75 3.58 3.81m-3.84-2.13c-.82 0-1.51.37-1.94 1.01v2.24q.72 1 1.94 1.01c1.2 0 1.99-.9 1.99-2.13s-.78-2.13-1.99-2.13m11.96 4.51a3.7 3.7 0 0 1-3.08 1.43c-2.5 0-3.92-1.75-3.92-3.8 0-2.1 1.32-3.82 3.63-3.82 1.96 0 3.25 1.33 3.25 3.18q-.02.62-.12 1H399c.17 1.31.98 1.84 2.09 1.84.77 0 1.44-.33 1.82-.84zm-3.42-4.73c-.9 0-1.5.5-1.7 1.43h3.25a1.46 1.46 0 0 0-1.55-1.43m5.03 5.88v-7.06h1.78v.7a2.5 2.5 0 0 1 1.86-.84q.36.01.62.1v1.75c-.23-.05-.46-.1-.79-.1-.86 0-1.42.48-1.69.93V233zm7.34.21c-1.42 0-2.38-.81-2.38-2.11 0-1.07.82-1.87 2.33-2.12l2.16-.36v-.18c0-.75-.56-1.22-1.37-1.22-.69 0-1.22.32-1.6.84l-1.3-1a3.5 3.5 0 0 1 2.95-1.4c2.05 0 3.1 1.22 3.1 2.78V233h-1.78v-.69c-.45.55-1.29.9-2.11.9m-.62-2.2c0 .48.38.79.98.79.81 0 1.4-.38 1.75-.94v-1l-1.68.28c-.74.13-1.05.44-1.05.87m7-.59v-2.88h-1.32v-1.6h1.31v-1.76h1.8v1.76h2.15v1.6h-2.16v2.88c0 .79.42 1.1 1.12 1.1.5 0 .82-.06 1.05-.16v1.56a3 3 0 0 1-1.35.22c-1.77 0-2.6-1-2.6-2.72m6.09 0v-2.88h-1.32v-1.6h1.32v-1.76h1.8v1.76h2.15v1.6h-2.16v2.88c0 .79.42 1.1 1.12 1.1.5 0 .81-.06 1.05-.16v1.56a3 3 0 0 1-1.36.22c-1.76 0-2.6-1-2.6-2.72m7.53 2.79c-1.42 0-2.38-.81-2.38-2.11 0-1.07.82-1.87 2.34-2.12l2.15-.36v-.18c0-.75-.56-1.22-1.37-1.22-.69 0-1.22.32-1.6.84l-1.3-1a3.5 3.5 0 0 1 2.96-1.4c2.04 0 3.09 1.22 3.09 2.78V233h-1.78v-.69c-.45.55-1.29.9-2.11.9m-.62-2.2c0 .48.38.79.98.79.81 0 1.4-.38 1.75-.94v-1l-1.68.28c-.74.13-1.05.44-1.05.87m6.04-1.54c0-2.06 1.35-3.8 3.59-3.8.95 0 1.63.3 2.18.85v-.58h1.8v10.5h-1.8v-4.01a3 3 0 0 1-2.18.85c-2.24 0-3.59-1.75-3.59-3.8m1.85 0c0 1.23.77 2.13 1.97 2.13.83 0 1.52-.36 1.95-1v-2.25q-.73-1-1.95-1c-1.2 0-1.97.89-1.97 2.12m12.5.48v-4h1.78v3.91c0 2.12-1.23 3.42-3.3 3.42s-3.29-1.3-3.29-3.42v-3.92h1.8v4c0 1.03.52 1.66 1.5 1.66.97 0 1.5-.63 1.5-1.65m10.25 1.9a3.7 3.7 0 0 1-3.08 1.43c-2.5 0-3.92-1.75-3.92-3.8 0-2.1 1.31-3.82 3.62-3.82 1.96 0 3.25 1.33 3.25 3.18q-.01.62-.11 1h-4.94c.17 1.31.98 1.84 2.08 1.84.77 0 1.45-.33 1.82-.84zm-3.42-4.73c-.9 0-1.51.5-1.7 1.43h3.24a1.46 1.46 0 0 0-1.54-1.43m4.32 4.86 1.17-1.07c.44.55.96.94 1.63.94.57 0 .87-.33.87-.75 0-1.24-3.38-.77-3.38-3.25 0-1.25 1.05-2.19 2.52-2.19 1.08 0 2.06.52 2.56 1.2l-1.17 1.04c-.37-.44-.83-.8-1.37-.8-.56 0-.83.3-.83.66 0 1.2 3.37.79 3.37 3.22-.02 1.49-1.21 2.3-2.54 2.3a3.5 3.5 0 0 1-2.83-1.3m7.78 1.19c-.68 0-1.23-.55-1.23-1.22a1.23 1.23 0 0 1 2.47 0c0 .67-.58 1.22-1.24 1.22"
        /><path
          fill="#fff"
          d="M264.23 215.83a1 1 0 0 1 0-1.66l6.21-4.18a1 1 0 0 1 1.56.83v8.36a1 1 0 0 1-1.56.83z"
        /></g
      ></g
    >&gt;<g class="profil">
      <g filter="url(#filter2_d_19244_36653)">
        <rect width="40" height="40" x="100" y="307" fill="url(#pattern1_19244_36653)" rx="20" /><rect
          width="38"
          height="38"
          x="101"
          y="308"
          stroke="#fff"
          stroke-width="2"
          rx="19"
        />
      </g>
      <g filter="url(#filter3_d_19244_36653)">
        <rect width="189" height="40" x="143" y="307" fill="#fff" rx="20" />
        <text fill="#161616" x="156" y="333" font-size="14">Djamaal, RSSI d'une ETI</text>
      </g>
    </g>
    <path
      stroke="#f5f5fe"
      stroke-linecap="round"
      stroke-miterlimit="10"
      stroke-width="3"
      d="M148.24 18.52a85 85 0 0 0-39.4 3.5c-10.52 3.53-20.65 9.43-27.13 18.42-6.47 9-8.69 21.55-3.74 31.5S96 87.7 106.09 83.09c4.88-2.26 8.85-7.77 6.92-12.73-2.22-5.84-10.13-6.51-16.26-5.58C63.62 70 35.57 98.18 30.62 131.2"
      class="trace"
      pathLength="1"
    /><path
      stroke="#f5f5fe"
      stroke-linecap="round"
      stroke-miterlimit="10"
      stroke-width="3"
      d="M27.8 142.09c-2.86.6-5.07 4.16-2.97 7.15 1.81 2.58 6.29 2.26 7.73-.56a4.9 4.9 0 0 0-1.26-5.67 4 4 0 0 0-3.5-.92Z"
      class="trace"
      pathLength="1"
    /></g
  ><defs
    ><filter
      id="filter0_d_19244_36653"
      width="108"
      height="108"
      x="8"
      y="152"
      color-interpolation-filters="sRGB"
      filterUnits="userSpaceOnUse"
      ><feFlood flood-opacity="0" result="BackgroundImageFix" /><feColorMatrix
        in="SourceAlpha"
        result="hardAlpha"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      /><feOffset dy="6" /><feGaussianBlur stdDeviation="9" /><feColorMatrix
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0705882 0 0 0 0.16 0"
      /><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_19244_36653" /><feBlend
        in="SourceGraphic"
        in2="effect1_dropShadow_19244_36653"
        result="shape"
      /></filter
    ><filter
      id="filter1_d_19244_36653"
      width="246.21"
      height="96"
      x="251.79"
      y="171"
      color-interpolation-filters="sRGB"
      filterUnits="userSpaceOnUse"
      ><feFlood flood-opacity="0" result="BackgroundImageFix" /><feColorMatrix
        in="SourceAlpha"
        result="hardAlpha"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      /><feOffset dy="4" /><feGaussianBlur stdDeviation="6" /><feColorMatrix
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0705882 0 0 0 0.16 0"
      /><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_19244_36653" /><feBlend
        in="SourceGraphic"
        in2="effect1_dropShadow_19244_36653"
        result="shape"
      /></filter
    ><filter
      id="filter2_d_19244_36653"
      width="64"
      height="64"
      x="88"
      y="299"
      color-interpolation-filters="sRGB"
      filterUnits="userSpaceOnUse"
      ><feFlood flood-opacity="0" result="BackgroundImageFix" /><feColorMatrix
        in="SourceAlpha"
        result="hardAlpha"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      /><feOffset dy="4" /><feGaussianBlur stdDeviation="6" /><feColorMatrix
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0705882 0 0 0 0.16 0"
      /><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_19244_36653" /><feBlend
        in="SourceGraphic"
        in2="effect1_dropShadow_19244_36653"
        result="shape"
      /></filter
    ><filter
      id="filter3_d_19244_36653"
      width="333"
      height="64"
      x="132"
      y="299"
      color-interpolation-filters="sRGB"
      filterUnits="userSpaceOnUse"
      ><feFlood flood-opacity="0" result="BackgroundImageFix" /><feColorMatrix
        in="SourceAlpha"
        result="hardAlpha"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      /><feOffset dy="4" /><feGaussianBlur stdDeviation="6" /><feColorMatrix
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0705882 0 0 0 0.16 0"
      /><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_19244_36653" /><feBlend
        in="SourceGraphic"
        in2="effect1_dropShadow_19244_36653"
        result="shape"
      /></filter
    ><pattern id="pattern0_19244_36653" width="1" height="1" patternContentUnits="objectBoundingBox"
      ><use href="#image0_19244_36653" transform="translate(-.606 -.217)scale(.00084)" /></pattern
    ><pattern id="pattern1_19244_36653" width="1" height="1" patternContentUnits="objectBoundingBox"
      ><use href="#image1_19244_36653" transform="translate(-1.359 -.286)scale(.00335)" /></pattern
    ><image
      id="image0_19244_36653"
      width="2528"
      height="1684"
      href="/assets/images/accueil/animation/heros/rssi.avif"
      preserveAspectRatio="none"
    /><image
      id="image1_19244_36653"
      width="1024"
      height="682"
      href="/assets/images/accueil/animation/heros/rssi-avatar.avif"
      preserveAspectRatio="none"
    /></defs
  ></svg
>

<style type="scss">
  svg {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
</style>
